import { render, staticRenderFns } from "./view-item.vue?vue&type=template&id=aa97f886&scoped=true"
import script from "./view-item.vue?vue&type=script&lang=js"
export * from "./view-item.vue?vue&type=script&lang=js"
import style0 from "./view-item.vue?vue&type=style&index=0&id=aa97f886&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa97f886",
  null
  
)

export default component.exports